import React from 'react'
import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import {
    updateProject,
    uploadFilesmultie,
    allurl,
    deleteProject,
    addCommasToNumber,
    getIcon,
    minusday,
    offerUid,
    getContract,
    getprojecthistory,
    myinfos,
} from '../../service/project'
import { FaRegFolderOpen } from 'react-icons/fa'
import ProjectTabs from '../../service/components/ProjectTabs'
import Projectsbox from '../../service/components/Projectsbox'
import Projectpgs from '../Project/Projectpgs'
import Projectedit from '../Project/Projedtedit'
import Swal from 'sweetalert2'
import { projectTabs } from '../../service/tabarray'
import { RiEdit2Fill } from 'react-icons/ri'

function MyProject({ project, setProject, userId }) {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const path = searchParams.get('uid')
    const navigate = useNavigate()

    const [selectedFiles, setSelectedFiles] = useState([])
    const [edit, setEdit] = useState(false)
    const [bProject, setbProject] = useState([])
    const [num, setNum] = useState(['전체', 0])
    const [pg, setPgs] = useState()
    const [uppg, setupPgs] = useState()
    const [contract, setContract] = useState([])
    const [bigL, setBigl] = useState('')
    const [offerlist, setOfferlist] = useState('')
    const [exdata, setExdata] = useState('')
    const [projecthistory, setprojecthistory] = useState('')
    const [userinfo, setUserinfo] = useState('')

    const [rightViewNum, setRightViewNum] = useState(0)
    const bigLabels = {}

    projectTabs.forEach((tab) => {
        const { biglabel, value, path, label, paths } = tab

        if (!bigLabels[biglabel]) {
            bigLabels[biglabel] = []
        }

        bigLabels[biglabel].push({ value, path, label, paths })
    })

    function toTime(value) {
        if (!value) return 0
        return new Date(String(value).replace(' ', 'T')).getTime() || 0
    }

    function getProjectCreatedTime(item) {
        return item.createdtime || item.a2 || item.createdAt || item.regdate || ''
    }

    function sortProjectList(list) {
        if (!Array.isArray(list)) return []

        return [...list].sort(function (a, b) {
            var timeA = toTime(getProjectCreatedTime(a))
            var timeB = toTime(getProjectCreatedTime(b))

            if (timeA !== timeB) {
                return timeB - timeA
            }

            return Number(b.id || 0) - Number(a.id || 0)
        })
    }

    function getDisplayProjects() {
        if (!Array.isArray(project)) return []

        var result = []

        if (!num || num[0] === '전체') {
            result = project
        } else {
            const biglabel = bigLabels[num[0]]

            if (!biglabel) {
                return []
            }

            result = project.filter(function (proj) {
                return biglabel.some(function (labelObj) {
                    return labelObj.label === proj.adminstatus
                })
            })
        }

        var sortedResult = sortProjectList(result)

        return sortedResult
    }

    const displayProjects = getDisplayProjects()

    const handleChanges = (value) => {
        setNum(value)
    }

    const handleChange = (category, itemName) => {
        if (category === 'minicate' || category === 'conditions') {
            const updatedMinicate = uppg[category].includes(itemName)
                ? uppg[category].filter((item) => item !== itemName)
                : [...uppg[category], itemName]

            setupPgs((prevData) => ({
                ...prevData,
                [category]: updatedMinicate,
            }))
        } else if (category === 'price') {
            const numericValue = parseFloat(itemName.replace(/,/g, ''))

            if (!isNaN(numericValue)) {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: addCommasToNumber(numericValue),
                }))
            } else {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: '',
                }))
            }
        } else if (category === 'clientphone') {
            const numericValue = itemName.replace(/-/g, '')

            if (numericValue.length === 10) {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: numericValue.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
                }))
            } else if (numericValue.length === 11) {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: numericValue.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'),
                }))
            } else {
                setupPgs((prevState) => ({
                    ...prevState,
                    [category]: itemName,
                }))
            }
        } else {
            setupPgs((prevState) => ({
                ...prevState,
                [category]: itemName,
            }))
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)

        if (path) {
            offerUid(path).then(function (response) {
                if (response.data) {
                    setOfferlist(response.data)
                }
            })

            getContract(path).then(function (response) {
                if (response.data) {
                    setContract(response.data[0])
                }
            })

            getprojecthistory(path).then(function (response) {
                if (response.data) {
                    setprojecthistory(response.data[0])
                }
            })
        }
    }, [path])

    useEffect(() => {
        getContract('exampledata').then(function (response) {
            if (response.data) {
                setExdata(response.data[0])
            }
        })

        myinfos(userId).then(function (response) {
            if (response.data) {
                setUserinfo(response.data[0])
            }
        })
    }, [userId])

    const uploadFiles = (projectId) => {
        uploadFilesmultie(projectId, selectedFiles)
    }

    const updates = () => {
        updateProject(
            uppg.title,
            uppg.email,
            uppg.company,
            uppg.cate,
            uppg.cateother,
            uppg.minicate,
            uppg.minicateother,
            uppg.outline,
            uppg.lastprojects,
            uppg.projects,
            uppg.needskill,
            uppg.price,
            uppg.startdate,
            uppg.term,
            uppg.contractcost,
            uppg.contractterm,
            uppg.pStatus,
            uppg.meet,
            uppg.client,
            uppg.clientphone,
            uppg.clientaddress,
            uppg.conditions,
            uppg.conditionother,
            uppg.uid,
        ).then(function (response) {
            if (response.data) {
                Swal.fire('수정 되었습니다', '확인 버튼을 눌러 주세요', 'success')

                uploadFiles(response.data.id)

                const selectedFiless = selectedFiles
                    .map((fileObj) => {
                        return `${allurl}/file_uploads/${fileObj.fileName}`
                    })
                    .join(',')

                uppg.files = selectedFiless

                navigate(`/Mypage/Myprojects/myProject?uid=${path}`)
                setEdit(!edit)
                setPgs({ ...uppg })
            } else {
                Swal.fire('오류가 발생하였습니다', '확인 버튼을 눌러 주세요', 'error')
            }
        })
    }

    const deleteProjects = (uid) => {
        Swal.fire({
            title: '임시 프로젝트를 삭제하시겠습니까?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '네',
            cancelButtonText: '아니요',
        }).then((result) => {
            if (result.isConfirmed) {
                deleteProject(uid).then(function () {
                    Swal.fire({
                        title: '삭제되었습니다!',
                        icon: 'success',
                    })

                    const newdata = project.filter((values) => values.uid !== uid)
                    setProject(newdata)
                })
            }
        })
    }

    function getVisibleBigLabels() {
        return Object.keys(bigLabels).filter(function (label) {
            return label !== '전체'
        })
    }

    function getCurrentMaxBigLabelIndex() {
        var labels = getVisibleBigLabels()

        if (!pg || !pg.adminstatus) {
            return 0
        }

        var maxIndex = 0

        labels.forEach(function (label, index) {
            var items = bigLabels[label] || []

            var matched = items.some(function (item) {
                return item.label === pg.adminstatus
            })

            if (matched) {
                maxIndex = index
            }
        })

        return maxIndex
    }

    function getCurrentBigLabelIndex() {
        var labels = getVisibleBigLabels()
        var currentIndex = labels.indexOf(bigL)

        if (currentIndex < 0) {
            return 0
        }

        return currentIndex
    }

    function moveBigLabel(direction) {
        var labels = getVisibleBigLabels()

        if (!labels || labels.length === 0) {
            return
        }

        var maxIndex = getCurrentMaxBigLabelIndex()
        var currentIndex = getCurrentBigLabelIndex()
        var nextIndex = currentIndex + direction

        if (nextIndex < 0) {
            nextIndex = 0
        }

        if (nextIndex > maxIndex) {
            nextIndex = maxIndex
        }

        setBigl(labels[nextIndex])
    }

    function getMaxRightViewNumByStatus() {
        if (!pg || !pg.adminstatus) return 0

        if (pg.adminstatus === '임시저장') return 0
        if (pg.adminstatus === '프로젝트 등록') return 0

        if (pg.adminstatus === '견적서 작성') return 1
        if (pg.adminstatus === '견적서 수신') return 1
        if (pg.adminstatus === '견적서 승인') return 1

        if (pg.adminstatus === '계약서 작성') return 3
        if (pg.adminstatus === '계약서 수신') return 3
        if (pg.adminstatus === '계약서 서명') return 3

        if (pg.adminstatus === '선금 납부') return 5
        if (pg.adminstatus === '1단계 개발') return 5
        if (pg.adminstatus === '1단계 보고서 수신') return 5
        if (pg.adminstatus === '1단계 보고서 승인') return 5

        if (pg.adminstatus === '중도금 납부') return 6
        if (pg.adminstatus === '2단계 개발') return 6
        if (pg.adminstatus === '2단계 보고서 수신') return 6
        if (pg.adminstatus === '2단계 보고서 승인') return 6

        if (pg.adminstatus === '3단계 개발') return 7
        if (pg.adminstatus === '3단계 보고서 수신') return 7
        if (pg.adminstatus === '3단계 보고서 승인') return 7
        if (pg.adminstatus === '잔금 납부') return 7

        if (pg.adminstatus === '프로젝트 완료') return 8

        return 0
    }

    function getViewSequence() {
        var max = getMaxRightViewNumByStatus()

        return [0, 1, 3, 5, 6, 7, 8].filter(function (num) {
            return num <= max
        })
    }

    function getRepresentativeTabByRightViewNum(viewNum) {
        if (viewNum === 0) return ['프로젝트등록', 1]
        if (viewNum === 1) return ['견적진행', 2]
        if (viewNum === 3) return ['계약진행', 3]

        if (viewNum === 5) return ['프로젝트 진행', 4]
        if (viewNum === 6) return ['프로젝트 진행', 4]
        if (viewNum === 7) return ['프로젝트 진행', 4]

        if (viewNum === 8) return ['프로젝트 완료', 5]

        return [bigL, num && num[1] ? num[1] : 0]
    }

    function getClientViewTitle(viewNum) {
        if (viewNum === 0) return '등록내용'
        if (viewNum === 1) return '견적서'
        if (viewNum === 3) return '계약서'
        if (viewNum === 5) return '1단계 개발'
        if (viewNum === 6) return '2단계 개발'
        if (viewNum === 7) return '3단계 개발'
        if (viewNum === 8) return '프로젝트 완료'

        return ''
    }

    function moveProjectView(direction) {
        var sequence = getViewSequence()
        var currentIndex = sequence.indexOf(rightViewNum)

        if (currentIndex < 0) {
            currentIndex = 0
        }

        var nextIndex = currentIndex + direction

        if (nextIndex < 0) {
            nextIndex = 0
        }

        if (nextIndex >= sequence.length) {
            nextIndex = sequence.length - 1
        }

        var nextViewNum = sequence[nextIndex]
        var nextTab = getRepresentativeTabByRightViewNum(nextViewNum)

        setRightViewNum(nextViewNum)
        setBigl(nextTab[0])
        setNum(nextTab)
    }

    function isFirstProjectView() {
        var sequence = getViewSequence()
        return sequence.indexOf(rightViewNum) <= 0
    }

    function isLastProjectView() {
        var sequence = getViewSequence()
        return sequence.indexOf(rightViewNum) >= sequence.length - 1
    }

    return (
        <>
            {/* <ProjectTabs type={'myproject'} array={project} num={num} setNum={handleChanges} bigLabels={bigLabels} /> */}
            {!path ? (
                <ProjectTabs
                    type={'myproject'}
                    array={project}
                    num={num}
                    setNum={handleChanges}
                    bigLabels={bigLabels}
                />
            ) : null}

            <div className="">
                {path && !edit ? (
                    <div className={'w1480 h100 flex addproject j'}>
                        <LeftMyProjectWrap>
                            {Object.entries(bigLabels).map(([biglabel, values]) => {
                                const otherValues = bigLabels && bigLabels[bigL && bigL]

                                const historyfind = (value) => {
                                    if (value !== 'e1') {
                                        let foundItem = null

                                        if (projecthistory && typeof projecthistory === 'object') {
                                            Object.keys(projecthistory).forEach((key) => {
                                                if (key === value) {
                                                    foundItem = projecthistory[key] && projecthistory[key].split(' ')[0]
                                                }
                                            })
                                        }

                                        return foundItem
                                    }

                                    return projecthistory && projecthistory.a2 ? projecthistory.a2.split(' ')[0] : ''
                                }

                                const historyfindf = (value) => {
                                    if (value !== 'e1') {
                                        let foundItem = null

                                        if (projecthistory && typeof projecthistory === 'object') {
                                            Object.keys(projecthistory).forEach((key) => {
                                                const targetKey = value + 'f'

                                                if (key === targetKey) {
                                                    foundItem = projecthistory[key] && projecthistory[key].split(' ')[0]
                                                }
                                            })
                                        }

                                        return foundItem
                                    }

                                    return projecthistory && projecthistory.e1 ? projecthistory.e1.split(' ')[0] : ''
                                }

                                const filteredValues = values.filter((value) => value.label !== '전체')

                                // function getClientStepValues(list) {
                                //     if (!Array.isArray(list)) return []

                                //     return list
                                // }
                                function getClientStepValues(list) {
                                    if (!Array.isArray(list)) return []

                                    return list.filter(function (item) {
                                        if (!item || !item.label) return false

                                        // 1. 등록내용
                                        if (rightViewNum === 0) {
                                            return item.label === '프로젝트 등록' || item.label === '임시저장'
                                        }

                                        // 2. 견적서
                                        if (rightViewNum === 1) {
                                            return item.label.includes('견적서')
                                        }

                                        // 3. 계약서
                                        if (rightViewNum === 3) {
                                            return item.label.includes('계약서')
                                        }

                                        // 4. 1단계 개발: 선금 납부 + 1단계 개발 보고서
                                        if (rightViewNum === 5) {
                                            return (
                                                item.label === '선금 납부' ||
                                                item.label === '1단계 개발' ||
                                                item.label === '1단계 보고서 수신' ||
                                                item.label === '1단계 보고서 승인'
                                            )
                                        }

                                        // 5. 2단계 개발: 중도금 납부 + 2단계 개발 보고서
                                        if (rightViewNum === 6) {
                                            return (
                                                item.label === '중도금 납부' ||
                                                item.label === '2단계 개발' ||
                                                item.label === '2단계 보고서 수신' ||
                                                item.label === '2단계 보고서 승인'
                                            )
                                        }

                                        // 6. 3단계 개발: 3단계 개발 보고서 + 잔금 납부
                                        if (rightViewNum === 7) {
                                            return (
                                                item.label === '3단계 개발' ||
                                                item.label === '3단계 보고서 수신' ||
                                                item.label === '3단계 보고서 승인' ||
                                                item.label === '잔금 납부'
                                            )
                                        }

                                        // 7. 프로젝트 완료
                                        if (rightViewNum === 8) {
                                            return item.label === '프로젝트 완료'
                                        }

                                        return false
                                    })
                                }

                                function getRawStepStatus(pathValue, valueNum, label) {
                                    const currentItem = projectTabs.find(function (item) {
                                        return item.label === pg.adminstatus
                                    })

                                    const currentValue = currentItem ? Number(currentItem.value) : -1

                                    if (label === '3단계 보고서 수신') {
                                        if (
                                            pg.adminstatus === '3단계 보고서 수신' ||
                                            pg.adminstatus === '3단계 보고서 승인' ||
                                            (contract && contract.develop3)
                                        ) {
                                            return 'done'
                                        }

                                        return 'wait'
                                    }

                                    if (label === '3단계 보고서 승인') {
                                        if ((contract && contract.r3f) || (projecthistory && projecthistory.r3f)) {
                                            return 'done'
                                        }

                                        if (pg.adminstatus === '3단계 보고서 승인') {
                                            return 'progress'
                                        }

                                        return 'wait'
                                    }

                                    const isProjectRegisterDone =
                                        pg && pg.adminstatus === '프로젝트 등록' && label === '프로젝트 등록'

                                    const isEstimateReceiveDone =
                                        pg && pg.adminstatus === '견적서 수신' && label === '견적서 수신'

                                    const isEstimateApproveDonePair =
                                        pg &&
                                        pg.adminstatus === '견적서 승인' &&
                                        (label === '견적서 수신' || label === '견적서 승인')

                                    const isContractReceiveDone =
                                        pg && pg.adminstatus === '계약서 수신' && label === '계약서 수신'

                                    const isContractSignDone =
                                        label === '계약서 서명' && projecthistory && projecthistory.c2f

                                    const isSpecialDone =
                                        isProjectRegisterDone ||
                                        isEstimateReceiveDone ||
                                        isEstimateApproveDonePair ||
                                        isContractReceiveDone ||
                                        isContractSignDone

                                    const isInProgress =
                                        !isSpecialDone &&
                                        ((biglabel !== '프로젝트등록' &&
                                            !historyfindf(pathValue) &&
                                            currentValue >= valueNum) ||
                                            (biglabel === '프로젝트등록' &&
                                                currentValue <= valueNum &&
                                                label === pg.adminstatus))

                                    const isCompleted = isSpecialDone || currentValue > valueNum

                                    if (isInProgress) return 'progress'
                                    if (isCompleted) return 'done'
                                    return 'wait'
                                }

                                function getStepStatusBadge(type) {
                                    if (type === 'done') {
                                        return <StepStatusBadge $type="done">완료</StepStatusBadge>
                                    }

                                    if (type === 'progress') {
                                        return <StepStatusBadge $type="active">진행중</StepStatusBadge>
                                    }

                                    return <StepStatusBadge $type="wait">대기</StepStatusBadge>
                                }
                                function normalizeStep(item) {
                                    const label = item.label || ''

                                    if (label.includes('1단계')) {
                                        return {
                                            group: '1단계 개발',
                                            sub: label.includes('수신')
                                                ? '수신'
                                                : label.includes('승인')
                                                ? '승인'
                                                : null,
                                        }
                                    }

                                    if (label.includes('2단계')) {
                                        return {
                                            group: '2단계 개발',
                                            sub: label.includes('수신')
                                                ? '수신'
                                                : label.includes('승인')
                                                ? '승인'
                                                : null,
                                        }
                                    }

                                    if (label.includes('3단계')) {
                                        return {
                                            group: '3단계 개발',
                                            sub: label.includes('수신')
                                                ? '수신'
                                                : label.includes('승인')
                                                ? '승인'
                                                : null,
                                        }
                                    }

                                    if (label.includes('선금')) {
                                        return {
                                            group: '선금 납부',
                                            sub: null,
                                        }
                                    }

                                    if (label.includes('중도금')) {
                                        return {
                                            group: '중도금 납부',
                                            sub: null,
                                        }
                                    }

                                    if (label.includes('잔금')) {
                                        return {
                                            group: '잔금 납부',
                                            sub: null,
                                        }
                                    }

                                    return {
                                        group: label,
                                        sub: null,
                                    }
                                }

                                function buildGroupedSteps(stepValues) {
                                    const grouped = []

                                    stepValues.forEach(function (item) {
                                        const normalized = normalizeStep(item)

                                        const found = grouped.find(function (v) {
                                            return v.group === normalized.group
                                        })

                                        if (!found) {
                                            grouped.push({
                                                group: normalized.group,
                                                main: normalized.sub ? null : item,
                                                subs: normalized.sub
                                                    ? [
                                                          {
                                                              label: normalized.sub,
                                                              item: item,
                                                          },
                                                      ]
                                                    : [],
                                            })
                                            return
                                        }

                                        if (normalized.sub) {
                                            found.subs.push({
                                                label: normalized.sub,
                                                item: item,
                                            })
                                        } else {
                                            found.main = item
                                        }
                                    })

                                    return grouped
                                }

                                function getDisplayCurrentLabel() {
                                    if (!pg || !pg.adminstatus) return ''

                                    if (pg.adminstatus === '견적서 수신') {
                                        return '견적서 승인'
                                    }

                                    if (pg.adminstatus === '계약서 수신') {
                                        return '계약서 서명'
                                    }

                                    return pg.adminstatus
                                }

                                function isPaymentGroup(groupName) {
                                    return (
                                        groupName === '선금 납부' ||
                                        groupName === '중도금 납부' ||
                                        groupName === '잔금 납부'
                                    )
                                }

                                function hasPositiveValue(value) {
                                    if (value === null || value === undefined || value === '') return false
                                    return Number(String(value).replace(/,/g, '')) > 0
                                }

                                function getPaymentConfirmFlag(groupName) {
                                    if (!contract) return false

                                    if (groupName === '선금 납부') {
                                        return !!((contract && contract.d2f) || (projecthistory && projecthistory.d2f))
                                    }

                                    if (groupName === '중도금 납부') {
                                        return !!((contract && contract.d4f) || (projecthistory && projecthistory.d4f))
                                    }

                                    if (groupName === '잔금 납부') {
                                        return !!((contract && contract.e1) || (projecthistory && projecthistory.e1))
                                    }

                                    return false
                                }

                                function hasPaymentInput(groupName) {
                                    if (!contract) return false

                                    if (groupName === '선금 납부') {
                                        return (
                                            hasPositiveValue(contract.beforemoney) ||
                                            !!(projecthistory && projecthistory.d1f)
                                        )
                                    }

                                    if (groupName === '중도금 납부') {
                                        return (
                                            hasPositiveValue(contract.middlemoney) ||
                                            !!(projecthistory && projecthistory.d3f)
                                        )
                                    }

                                    if (groupName === '잔금 납부') {
                                        return (
                                            hasPositiveValue(contract.aftermoney) ||
                                            !!(projecthistory && projecthistory.d6f)
                                        )
                                    }

                                    return false
                                }

                                function getPaymentSubItems(groupName, target) {
                                    if (!isPaymentGroup(groupName) || !target) return []

                                    const paid = hasPaymentInput(groupName)
                                    const confirmed = getPaymentConfirmFlag(groupName)
                                    const isCurrentPaymentStep = pg && pg.adminstatus === groupName

                                    return [
                                        {
                                            label: '입금',
                                            type: paid ? 'done' : isCurrentPaymentStep ? 'progress' : 'wait',
                                            active: !paid && isCurrentPaymentStep,
                                            item: target,
                                        },
                                        {
                                            label: '확인',
                                            type: confirmed
                                                ? 'done'
                                                : paid && isCurrentPaymentStep
                                                ? 'progress'
                                                : 'wait',
                                            active: !confirmed && paid && isCurrentPaymentStep,
                                            item: target,
                                        },
                                    ]
                                }

                                function isGroupActive(group) {
                                    const displayCurrentLabel = getDisplayCurrentLabel()

                                    if (group.main && displayCurrentLabel === group.main.label) {
                                        return true
                                    }

                                    if (displayCurrentLabel === group.group) {
                                        return true
                                    }

                                    return group.subs.some(function (sub) {
                                        return displayCurrentLabel === sub.item.label
                                    })
                                }

                                function getGroupedStatus(group) {
                                    if (group.group === '1단계 개발') {
                                        if (contract && contract.r1f) return 'done'
                                        if (
                                            pg.adminstatus &&
                                            (pg.adminstatus.includes('1단계') || pg.adminstatus === '중도금 납부')
                                        ) {
                                            return 'progress'
                                        }
                                        return 'wait'
                                    }

                                    if (group.group === '2단계 개발') {
                                        if (contract && contract.r2f) return 'done'
                                        if (pg.adminstatus && pg.adminstatus.includes('2단계')) {
                                            return 'progress'
                                        }
                                        return 'wait'
                                    }

                                    if (group.group === '3단계 개발') {
                                        if ((contract && contract.r3f) || (projecthistory && projecthistory.r3f)) {
                                            return 'done'
                                        }

                                        if (pg.adminstatus && pg.adminstatus.includes('3단계')) {
                                            return 'progress'
                                        }

                                        return 'wait'
                                    }

                                    if (group.group === '선금 납부') {
                                        if (getPaymentConfirmFlag('선금 납부')) return 'done'
                                        if (pg.adminstatus === '선금 납부') return 'progress'
                                        return 'wait'
                                    }

                                    if (group.group === '중도금 납부') {
                                        if (getPaymentConfirmFlag('중도금 납부')) return 'done'
                                        if (pg.adminstatus === '중도금 납부') return 'progress'
                                        return 'wait'
                                    }

                                    if (group.group === '잔금 납부') {
                                        if (getPaymentConfirmFlag('잔금 납부')) return 'done'
                                        if (pg.adminstatus === '잔금 납부') return 'progress'
                                        return 'wait'
                                    }

                                    if (group.group === '프로젝트 완료') {
                                        if (pg && pg.adminstatus === '프로젝트 완료') {
                                            return 'done'
                                        }

                                        return 'wait'
                                    }

                                    const target = group.main || (group.subs[0] && group.subs[0].item)

                                    if (!target) return 'wait'

                                    return getRawStepStatus(target.path, target.value, target.label)
                                }

                                function getSubStatusBadge(label, type, active) {
                                    return (
                                        <StepSubBadge $type={type} $active={active}>
                                            {label}
                                        </StepSubBadge>
                                    )
                                }

                                const clientFilteredValues = getClientStepValues(filteredValues)
                                const groupedSteps = buildGroupedSteps(clientFilteredValues)

                                if (biglabel == bigL && pg) {
                                    return (
                                        <div key={values[0].value}>
                                            <StepContainer>
                                                <StepContent>
                                                    <StepTitleRow>
                                                        <StepTitleLeft>
                                                            <StepMoveButton
                                                                type="button"
                                                                onClick={() => moveProjectView(-1)}
                                                                disabled={isFirstProjectView()}
                                                            >
                                                                &lt;
                                                            </StepMoveButton>

                                                            <StepCenterTitle>
                                                                <StepTitleText>
                                                                    {getClientViewTitle(rightViewNum)}
                                                                </StepTitleText>
                                                            </StepCenterTitle>

                                                            <StepMoveButton
                                                                type="button"
                                                                onClick={() => moveProjectView(1)}
                                                                disabled={isLastProjectView()}
                                                            >
                                                                &gt;
                                                            </StepMoveButton>
                                                        </StepTitleLeft>
                                                    </StepTitleRow>
                                                    <StepContain>
                                                        <StepList>
                                                            {groupedSteps.map((group, index) => {
                                                                const target =
                                                                    group.main || (group.subs[0] && group.subs[0].item)

                                                                if (!target) {
                                                                    return null
                                                                }

                                                                const groupStatus = getGroupedStatus(group)
                                                                const startDate = historyfind(target.path)
                                                                const endDate = historyfindf(target.path)
                                                                const hideRange =
                                                                    biglabel === '프로젝트등록' ||
                                                                    target.path === '견적서 수신'

                                                                const groupDone = groupStatus === 'done'
                                                                const groupActive = !groupDone && isGroupActive(group)
                                                                const paymentSubs = getPaymentSubItems(
                                                                    group.group,
                                                                    target,
                                                                )
                                                                const renderSubs =
                                                                    paymentSubs.length > 0 ? paymentSubs : group.subs

                                                                return (
                                                                    <StepItem key={group.group + index}>
                                                                        <StepRow>
                                                                            <StepLabelWrap>
                                                                                <StepCircle
                                                                                    $active={groupActive}
                                                                                    $done={groupDone}
                                                                                >
                                                                                    {index + 1}
                                                                                </StepCircle>

                                                                                <StepLabel
                                                                                    $active={groupActive}
                                                                                    $done={groupDone}
                                                                                >
                                                                                    {group.group}
                                                                                </StepLabel>
                                                                            </StepLabelWrap>

                                                                            {getStepStatusBadge(groupStatus)}
                                                                        </StepRow>

                                                                        {renderSubs.length > 0 ? (
                                                                            <StepSubWrap>
                                                                                {renderSubs.map(function (sub) {
                                                                                    if (paymentSubs.length > 0) {
                                                                                        return (
                                                                                            <React.Fragment
                                                                                                key={
                                                                                                    group.group +
                                                                                                    sub.label
                                                                                                }
                                                                                            >
                                                                                                {getSubStatusBadge(
                                                                                                    sub.label,
                                                                                                    sub.type,
                                                                                                    sub.active,
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                        )
                                                                                    }

                                                                                    const subStatus = getRawStepStatus(
                                                                                        sub.item.path,
                                                                                        sub.item.value,
                                                                                        sub.item.label,
                                                                                    )
                                                                                    const subActive =
                                                                                        getDisplayCurrentLabel() ===
                                                                                        sub.item.label

                                                                                    return (
                                                                                        <React.Fragment
                                                                                            key={
                                                                                                group.group + sub.label
                                                                                            }
                                                                                        >
                                                                                            {getSubStatusBadge(
                                                                                                sub.label,
                                                                                                subStatus,
                                                                                                subActive,
                                                                                            )}
                                                                                        </React.Fragment>
                                                                                    )
                                                                                })}
                                                                            </StepSubWrap>
                                                                        ) : null}

                                                                        <StepDateRow>
                                                                            <StepDateLineWrap>
                                                                                <StepVerticalBar />
                                                                                <StepHorizontalBar />

                                                                                <StepDateTextWrap>
                                                                                    <StepDateText>
                                                                                        {biglabel === '프로젝트등록'
                                                                                            ? startDate
                                                                                            : target.label ===
                                                                                                  '견적서 수신' ||
                                                                                              target.label ===
                                                                                                  '계약서 수신' ||
                                                                                              target.label ===
                                                                                                  '1단계 개발' ||
                                                                                              target.label ===
                                                                                                  '2단계 개발' ||
                                                                                              target.label ===
                                                                                                  '3단계 개발'
                                                                                            ? startDate
                                                                                            : endDate}
                                                                                    </StepDateText>
                                                                                </StepDateTextWrap>
                                                                            </StepDateLineWrap>
                                                                        </StepDateRow>
                                                                    </StepItem>
                                                                )
                                                            })}
                                                        </StepList>
                                                    </StepContain>
                                                </StepContent>
                                            </StepContainer>

                                            <StepActionRow>
                                                {path &&
                                                !edit &&
                                                (pg.adminstatus === '임시저장' ||
                                                    pg.adminstatus === '프로젝트 등록') ? (
                                                    <EditActionWrap>
                                                        <EditIconWrap>
                                                            <RiEdit2Fill />
                                                        </EditIconWrap>

                                                        <button onClick={() => setEdit(!edit)} className="retouch-box">
                                                            프로젝트 수정
                                                        </button>
                                                    </EditActionWrap>
                                                ) : (
                                                    ''
                                                )}
                                            </StepActionRow>
                                        </div>
                                    )
                                }

                                return null
                            })}
                        </LeftMyProjectWrap>

                        <Projectpgs
                            offerlist={offerlist}
                            userinfo={userinfo}
                            exdata={exdata}
                            setBigl={setBigl}
                            bigLabels={bigLabels}
                            num={num}
                            setNum={setNum}
                            contract={contract}
                            setContract={setContract}
                            my={true}
                            setupPgs={setupPgs}
                            edit={edit}
                            setEdit={setEdit}
                            pg={pg}
                            setPgs={setPgs}
                            right={true}
                            path={path}
                            setprojecthistory={setprojecthistory}
                            rightViewNum={rightViewNum}
                            setRightViewNum={setRightViewNum}
                        />
                    </div>
                ) : path && edit ? (
                    <Projectedit
                        setSelectedFiles={setSelectedFiles}
                        selectedFiles={selectedFiles}
                        my={true}
                        updates={updates}
                        path={path}
                        handleChange={handleChange}
                        pg={uppg}
                    />
                ) : (
                    <ul className="project__wrap" key={num && num[0] ? num[0] : '전체'}>
                        {displayProjects.length > 0 ? (
                            displayProjects.map((value, index) => (
                                <Projectsbox
                                    contract={contract}
                                    deleteProjects={deleteProjects}
                                    data={displayProjects}
                                    my={true}
                                    key={`${value.uid || value.id || 'project'}-${index}`}
                                    value={value}
                                />
                            ))
                        ) : (
                            <div className="empty flex c a min300 ">
                                <FaRegFolderOpen />
                                <span className="ml10">등록된 프로젝트가 없습니다</span>
                            </div>
                        )}
                    </ul>
                )}
            </div>
        </>
    )
}

export default MyProject

// const BLUE = '#1baacc'

// 1순위
const CURRENT_BLUE = '#1baacc'
const DONE_BLUE = '#b8e8f1'
const DONE_BORDER = '#5fc7da'
const DONE_TEXT = '#166c7d'
const WAIT_BG = '#f1f3f5'
const WAIT_BORDER = '#c8ced6'
const WAIT_TEXT = '#6b7280'

// 2순위
// const BLUE = '#000046'
// const CURRENT_BLUE = '#000046'
// const DONE_BLUE = '#d9dcf3'
// const DONE_BORDER = '#aab2df'
// const DONE_TEXT = '#3f4a8a'
// const WAIT_BG = '#f3f4fa'
// const WAIT_BORDER = '#d4d8e8'
// const WAIT_TEXT = '#7d849f'

const LeftMyProjectWrap = styled.div`
    width: 280px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    position: relative;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    height: auto;

    align-self: flex-start;
`

const StepSubWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 38px;
    margin-top: 6px;
    margin-bottom: 4px;
    flex-wrap: wrap;
`

const StepSubBadge = styled.span`
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 700;
    border: 1px solid
        ${(props) =>
            props.$active
                ? CURRENT_BLUE
                : props.$type === 'done'
                ? DONE_BORDER
                : props.$type === 'progress'
                ? CURRENT_BLUE
                : WAIT_BORDER};
    color: ${(props) =>
        props.$active
            ? '#ffffff'
            : props.$type === 'done'
            ? DONE_TEXT
            : props.$type === 'progress'
            ? '#ffffff'
            : WAIT_TEXT};
    background-color: ${(props) =>
        props.$active
            ? CURRENT_BLUE
            : props.$type === 'done'
            ? DONE_BLUE
            : props.$type === 'progress'
            ? CURRENT_BLUE
            : WAIT_BG};
`

const StepContainer = styled.div``

const StepContent = styled.div``

const StepTitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 20px;
`
const StepTitleLeft = styled.div`
    display: grid;
    grid-template-columns: 36px 1fr 36px;
    align-items: center;
    width: 100%;
    margin-left: -9px;
`

const StepCenterTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 0;
    margin-left: 15px;
`

const StepIconWrap = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-left: 15px;
`

const StepTitleText = styled.span`
    font-size: 20px;
    font-weight: 700;
    color: #212121;
    line-height: 1.3;
`
const StepDDay = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    min-width: 60px;
    height: 28px;
    padding: 5px;
    border-radius: 5px;
    border: 1px dotted #8d8d8d;
    border-radius: 8px;
    color: #212121;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
`

const StepContain = styled.div`
    width: 100%;
    max-height: unset;
    overflow-y: visible;
    overflow-x: hidden;
    padding-right: 0;
`

const StepList = styled.ul`
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
`

const StepItem = styled.li`
    width: 100%;
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
`

const StepRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 5px 0;
`

const StepLabelWrap = styled.span`
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
`

const StepCircle = styled.div`
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 50%;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    border: 2px solid ${(props) => (props.$active ? CURRENT_BLUE : props.$done ? DONE_BORDER : WAIT_BORDER)};
    background: ${(props) => (props.$active ? CURRENT_BLUE : props.$done ? DONE_BLUE : WAIT_BG)};
    color: ${(props) => (props.$active ? '#ffffff' : props.$done ? DONE_TEXT : '#4d5b6a')};
    box-sizing: border-box;
`

const StepLabel = styled.span`
    min-width: 0;
    word-break: keep-all;
    line-height: 1.4;
    font-size: 15px;
    font-weight: ${(props) => (props.$active ? 800 : props.$done ? 700 : 600)};
    color: ${(props) => (props.$active ? CURRENT_BLUE : props.$done ? DONE_TEXT : '#5d6773')};
`

const StepStatusBadge = styled.span`
    width: 60px;
    min-width: 60px;
    height: 28px;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
    font-weight: 700;
    box-sizing: border-box;
    color: ${(props) => (props.$type === 'active' ? '#ffffff' : props.$type === 'done' ? DONE_TEXT : WAIT_TEXT)};
    background-color: ${(props) =>
        props.$type === 'active' ? CURRENT_BLUE : props.$type === 'done' ? DONE_BLUE : WAIT_BG};
    border: 1px solid
        ${(props) => (props.$type === 'active' ? CURRENT_BLUE : props.$type === 'done' ? DONE_BORDER : WAIT_BORDER)};
`

const StepDateRow = styled.div`
    display: flex;
    width: 100%;
`

const StepDateLineWrap = styled.div`
    position: relative;
    width: 100%;
    min-height: 36px;
    margin-left: 14px;
    display: flex;
    align-items: center;
`

const StepVerticalBar = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 2px;
    height: 24px;
    background-color: #c0c7d1;
`

const StepHorizontalBar = styled.div`
    position: absolute;
    left: 0;
    top: 24px;
    width: 34px;
    height: 2px;
    background-color: #c0c7d1;
`

const StepDateTextWrap = styled.span`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    margin-left: 44px;
    padding: 6px 10px;
    border-radius: 8px;
    background: #f8fafc;
`

const StepDateText = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: #7a8591;
    line-height: 1.5;
`

const StepActionRow = styled.div`
    display: flex;
    justify-content: flex-end;
`

const EditActionWrap = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 20px;
`

const EditIconWrap = styled.span`
    display: inline-flex;
    margin-right: 10px;
    font-size: 22px;
`

const StepMoveButton = styled.button`
    width: 36px;
    height: 32px;
    padding: 0;
    margin: 0 8px;
    border: none;
    border-radius: 4px;
    background: #1baacc;
    color: #fff;
    font-size: 16px;
    font-weight: 800;
    cursor: pointer;
    text-align: center;
    line-height: 32px;
    flex-shrink: 0;

    &:disabled {
        background: #d6d6d6;
        color: #888;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        background: #668cc8;
    }
`
